import { Reducer } from "redux";

interface State {
    token: string,
    logado: boolean,
    tenantId: string,
    expirado: boolean,
    administrador: boolean,
    tentativasDeLogin: number,
    ultimaTentativaDeLogin?: Date,
}

const INITIAL_STATE: State = {
    token: "",
    tenantId: "",
    logado: false,
    expirado: false,
    administrador: false,
    tentativasDeLogin: 0,
    ultimaTentativaDeLogin: undefined,
};

const reducer: Reducer<State> = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case "LOG_IN":
            return { ...state, token: action.token, tenantId: action.tenantId, logado: true, expirado: false, administrador: action.administrador, tentativasDeLogin: 0, ultimaTentativaDeLogin: undefined, }
        case "LOG_OUT":
            return { ...state, token: "", tenantId: "", logado: false, expirado: false, administrador: false, }
        case "LOG_OUT_EXPIRED":
            return { ...state, token: "", tenantId: "", logado: false, expirado: true, administrador: false, }
        case "LOG_IN_FAILED":
            return { ...state, tentativasDeLogin: state.tentativasDeLogin + 1, ultimaTentativaDeLogin: new Date(), };
        case "RESET_LOGIN_ATTEMPTS":
            return { ...state, tentativasDeLogin: 0, ultimaTentativaDeLogin: undefined, };
        default:
            return state;
    }
}

export default reducer;